import type { enEditor } from "./en.editor";

/** Russian for the campaign editor (see `en.editor.ts`). Words from the boards E*. */
export const ruEditor: Record<keyof typeof enEditor, string> = {
  "ed.titleNew": "Новая кампания",
  "ed.titleEdit": "Изменить кампанию",
  "ed.name": "Название кампании",
  "ed.name.placeholder": "Vlad [PL] | Joints | Relieflex | 97 ZL | u15",
  "ed.cancel": "Отмена",
  "ed.back": "К кампаниям",
  "ed.notFound": "Кампания не найдена",
  "ed.draftSaved": "черновик сохранён {ago} назад",
  "ed.draftLocal": "черновик хранится в этом браузере",
  "ed.changedAt": "изменено {at}",
  "ed.changedUnsaved": "изменено {at} · не сохранено",
  "ed.saved": "Сохранено — изменения применятся к новым кликам",
  "ed.conflict": "Кампанию только что изменили в другом окне — обновите страницу",
  "ed.failed": "Не получилось — попробуйте ещё раз",
  "ed.fixFirst": "Есть что поправить — раздел открыт",
  "ed.sections": "Разделы кампании",
  "ed.legend.ok": "заполнено",
  "ed.legend.warn": "есть что поправить",
  "ed.legend.empty": "не заполнено",
  "ed.legend.opt": "по желанию",
  "ed.optional": "по желанию",
  "ed.open": "Открыть",
  "ed.setUp": "Настроить",
  "ed.loading": "загружаем…",
  "ed.more": "Ещё",
  "ed.remove": "Убрать",
  "ed.copy": "Копировать",
  "ed.copied": "Скопировано",
  "ed.retry": "Повторить",
  "ed.search.error": "Не удалось найти — сервер не ответил",
  "ed.search.empty": "Ничего не нашлось",
  "ed.search.navigate": "выбрать",
  "ed.search.choose": "добавить",
  "ed.source.title": "Источник",
  "ed.source.sub": "Откуда идёт трафик и куда отдаём лиды",
  "ed.source.platform": "Площадка",
  "ed.source.none": "Источников нет — добавьте в Библиотеке → Источники",
  "ed.source.clickId": "клики из {param}",
  "ed.source.pixel": "Пиксель {brand}",
  "ed.source.pixel.hint": "лиды уйдут в пиксель через CAPI",
  "ed.source.leads": "Куда ведёт реклама",
  "ed.source.leads.pick": "Схема потока",
  "ed.source.leads.graph": "Поток собран админом",
  "ed.source.leads.handBuilt": "поток этой кампании собран админом в графе — меняет его админ",
  "ed.source.group": "Группа",
  "ed.source.group.hint": "одна группа на кампанию — для свода по группам",
  "ed.source.group.none": "Без группы",
  "ed.source.group.search": "Найти группу",
  "ed.source.group.count": "кампаний: {n}",
  "ed.source.group.new": "Новая",
  "ed.source.group.create": "Создать группу «{name}»",
  "ed.source.groups": "Группы",
  "ed.source.tags": "Теги",
  "ed.source.tags.hint": "свободные метки для отчётов",
  "ed.source.tags.placeholder": "тег…",
  "ed.source.notes": "Заметки",
  "ed.offers.title": "Офферы и ленды",
  "ed.offers.sub": "Что увидит человек и куда уйдёт лид",
  "ed.offers.count": "офферы: {offers} · ленды: {landers}",
  "ed.offers.how": "Посетитель видит ленд по долям лендов, потом попадает в оффер по долям офферов. Правила потока срабатывают раньше долей.",
  "ed.offers.offers": "Офферы",
  "ed.offers.offersNote": "доли офферов · сумма 100%",
  "ed.offers.landers": "Ленды",
  "ed.offers.landersNote": "доли лендов · один список для всех офферов",
  "ed.offers.address": "адрес есть",
  "ed.offers.noAddress": "адреса нет",
  "ed.offers.shareOf": "Доля: {name}",
  "ed.offers.open": "Открыть оффер",
  "ed.offers.noneOffers": "Офферов пока нет",
  "ed.offers.noneLanders": "Лендов пока нет",
  "ed.offers.addOffer": "Оффер",
  "ed.offers.addLander": "Ленд",
  "ed.offers.searchOffer": "Найти оффер",
  "ed.offers.searchLander": "Найти ленд",
  "ed.offers.searchGroup": "Офферы",
  "ed.offers.searchGroupIn": "Офферы · {countries}",
  "ed.offers.inCampaign": "уже в кампании",
  "ed.offers.paused": "пауза",
  "ed.offers.otherCountry": "другая страна",
  "ed.offers.landerEmpty": "не опубликован",
  "ed.offers.split": "доли {split}",
  "ed.offers.sumOk": "сумма долей 100% · ок",
  "ed.offers.sumOff": "сумма долей {sum}% — поправьте на {diff}%",
  "ed.offers.fixSum": "сумма долей {sum}% — поправьте до 100",
  "ed.offers.sticky": "Держим ленд и оффер 24 часа",
  "ed.offers.sticky.hint": "вернувшийся человек увидит тот же ленд и оффер",
  "ed.offers.thankYou": "Страница «Спасибо»",
  "ed.offers.thankYou.hint": "показывается после отправки формы на ленде",
  "ed.offers.thankYou.default": "своя страница ленда, иначе по умолчанию",
  "ed.lander.type.landing": "Ленд",
  "ed.lander.type.prelanding": "Преленд",
  "ed.lander.type.vsl": "VSL",
  "ed.lander.type.white": "Белая страница",
  "ed.lander.type.thanks": "Спасибо",
  "ed.lander.risk.safe": "безопасно",
  "ed.lander.risk.warn": "есть риск",
  "ed.lander.risk.danger": "опасно",
  "ed.rules.title": "Правила потока",
  "ed.rules.sub": "Кому что показать до долей",
  "ed.rules.n": "Правило {n}",
  "ed.rules.clicks": "{share} кликов",
  "ed.rules.rest": "Остальные",
  "ed.rules.restTarget": "по долям офферов и лендов",
  "ed.rules.shares": "Доли",
  "ed.rules.add": "Правило",
  "ed.rules.edit": "Изменить",
  "ed.rules.remove": "Убрать правило",
  "ed.rules.move": "Переместить — перетащите или Alt+↑/↓",
  "ed.rules.order": "Правила проверяются сверху вниз, срабатывает первое подходящее. Порядок меняется перетаскиванием. Время — по {tz}.",
  "ed.rules.moved": "«{name}» теперь {n}-е",
  "ed.rules.empty": "Правил нет — все идут по долям",
  "ed.rules.replayNote": "доли — сколько кликов за {days} дней взяло бы каждое правило из {total}; считает сервер по кликам кампании",
  "ed.rules.adminNote": "Сложные схемы (несколько шагов, переходы между лендами) настраивает админ. Баеру хватает правил и веток ухода.",
  "ed.rules.handBuilt": "Поток этой кампании собран админом в графе — правила и ветки в нём, меняет их админ.",
  "ed.rules.openGraph": "Открыть граф",
  "ed.rules.kind.offer": "оффер",
  "ed.rules.kind.lander": "ленд",
  "ed.rules.kind.white": "белая страница",
  "ed.rules.kind.url": "адрес",
  "ed.rules.noTarget": "куда — не выбрано",
  "ed.rules.pickTarget": "Выбрать…",
  "ed.rules.device.mobile": "телефон",
  "ed.rules.device.tablet": "планшет",
  "ed.rules.device.desktop": "компьютер",
  "ed.rules.w.country": "Если страна {list}",
  "ed.rules.w.countryPre": "Если страна",
  "ed.rules.w.not": "не",
  "ed.rules.w.device": "Если устройство — {list}",
  "ed.rules.w.bot": "Если бот или краулер",
  "ed.rules.w.schedule": "Если время {from}–{to}",
  "ed.rules.w.param": "Если в ссылке нет",
  "ed.rules.w.pick": "Если …",
  "ed.rules.f.country": "Страна",
  "ed.rules.f.device": "Устройство",
  "ed.rules.f.bot": "Бот",
  "ed.rules.f.botValue": "бот или краулер",
  "ed.rules.f.schedule": "Время",
  "ed.rules.f.param": "Ключ в ссылке",
  "ed.rules.op.notIn": "не из",
  "ed.rules.op.in": "из",
  "ed.rules.op.is": "это",
  "ed.rules.op.hours": "в часы",
  "ed.rules.op.ne": "нет",
  "ed.rules.op.paramAbsent": "нет ключа",
  "ed.rules.op.paramPresent": "есть ключ",
  "ed.rules.hoursUnit": "ч",
  "ed.rules.days": "Дни",
  "ed.rules.daysHint": "пусто — каждый день; время по {tz}",
  "ed.rules.dialog.sub": "Срабатывает раньше долей. Первое подходящее правило побеждает.",
  "ed.rules.dialog.field": "Условие",
  "ed.rules.dialog.values": "Значения",
  "ed.rules.dialog.outcome": "Тогда отправить на",
  "ed.rules.dialog.preview": "Как прочитается",
  "ed.rules.dialog.save": "Сохранить правило",
  "ed.rules.dialog.delete": "Удалить правило",
  "ed.rules.replay": "За {days} дней под правило попали бы {n} из {total} кликов ({share}).",
  "ed.rules.replay.param": "Ключ ссылки трекер не хранит — сколько кликов попали бы, заранее не посчитать.",
  "ed.rules.replay.wait": "считаем по кликам кампании…",
  "ed.rules.replay.new": "У новой кампании кликов ещё нет — доли появятся после запуска.",
  "ed.day.1": "пн",
  "ed.day.2": "вт",
  "ed.day.3": "ср",
  "ed.day.4": "чт",
  "ed.day.5": "пт",
  "ed.day.6": "сб",
  "ed.day.7": "вс",
  "ed.branches.title": "Ветки ухода",
  "ed.branches.on": "{on} из {total} включены",
  "ed.branches.how": "Что показать человеку, который уже на ленде, но собирается уйти. Срабатывает на ленде, а не на клике.",
  "ed.branches.handBuilt": "Ветки этой кампании — узлы графа админа.",
  "ed.branches.back": "Кнопка «назад»",
  "ed.branches.back.sub": "человек жмёт «назад» в браузере",
  "ed.branches.exit": "Уход со страницы",
  "ed.branches.exit.sub": "курсор к закрытию вкладки, только компьютер",
  "ed.branches.idle": "Бездействие",
  "ed.branches.idle.sub": "человек ничего не делает",
  "ed.branches.scroll": "Дочитал до конца",
  "ed.branches.scroll.sub": "долистал ленд до низа и не нажал кнопку",
  "ed.branches.idleSeconds": "Секунд без действий",
  "ed.branches.idleBounds": "от {min} до {max} секунд",
  "ed.branches.sec": "с",
  "ed.branches.where": "Куда",
  "ed.branches.search": "Найти ленд или оффер",
  "ed.branches.both": "сначала ленд по долям, с него — оффер ветки по долям",
  "ed.branches.landersOnly": "с ленда ветки — в офферы кампании",
  "ed.domain.title": "Домен",
  "ed.domain.sub": "Адрес, на котором живёт рекламная ссылка",
  "ed.domain.domain": "Домен",
  "ed.domain.path": "Путь",
  "ed.domain.path.placeholder": "из названия",
  "ed.domain.path.auto": "из названия",
  "ed.domain.pick": "Выбрать домен",
  "ed.domain.search": "Найти домен",
  "ed.domain.own": "Мои домены",
  "ed.domain.ownBadge": "подключим",
  "ed.domain.ownBlocked": "нельзя",
  "ed.domain.ownServes": "ваш домен — трекер уже на нём",
  "ed.domain.bound": "Подключённые",
  "ed.domain.blocked": "Нельзя",
  "ed.domain.connect": "Подключить домен…",
  "ed.domain.takeOnSave": "ваш домен — подключим при сохранении",
  "ed.domain.https": "HTTPS выдан",
  "ed.domain.httpsShort": "HTTPS",
  "ed.domain.off": "домен выключен",
  "ed.domain.dns": "DNS → трекер",
  "ed.domain.dnsFailed": "DNS не отвечает",
  "ed.domain.dnsPending": "DNS ещё проверяется",
  "ed.domain.checked": "проверен {at}",
  "ed.domain.none": "домена нет — ссылке негде жить",
  "ed.domain.preview": "Так будет выглядеть ссылка",
  "ed.cost.title": "Расход",
  "ed.cost.sub": "Как трекер узнаёт, сколько потрачено",
  "ed.cost.auto": "Из {brand}",
  "ed.cost.auto.hint": "расход по объявлениям приходит раз в 15 мин; нужен доступ к кабинету",
  "ed.cost.auto.notFb": "{brand} расход сам не присылает — выберите за клик или вручную",
  "ed.cost.cpc": "За клик",
  "ed.cost.cpa": "За лид",
  "ed.cost.revshare": "Доля дохода",
  "ed.cost.manual": "Вручную по периодам",
  "ed.cost.manual.hint": "для TikTok и источников без API: сумма делится по кликам периода",
  "ed.cost.rate": "Ставка",
  "ed.cost.percent": "Процент",
  "ed.cost.perClick": "USD за клик",
  "ed.cost.perLead": "USD за лид",
  "ed.cost.from": "С",
  "ed.cost.to": "По",
  "ed.cost.amount": "Сумма",
  "ed.cost.usdTotal": "USD всего",
  "ed.cost.addPeriod": "Период",
  "ed.cost.overlap": "периоды не должны пересекаться",
  "ed.cost.gap": "пропуск {day} → расход за этот день = 0",
  "ed.cost.total": "периодов: {n}, {sum} USD",
  "ed.cost.noPeriods": "периодов ещё нет",
  "ed.cost.currency": "Валюта расхода",
  "ed.cost.currency.hint": "трекер считает деньги в USD",
  "ed.cost.noClicks": "Расход без кликов",
  "ed.cost.noClicks.value": "Показываем отдельной строкой",
  "ed.cost.noClicks.hint": "деньги не теряются, если кликов в периоде нет",
  "ed.postbacks.title": "Постбеки",
  "ed.postbacks.sub": "Как партнёрка сообщает о лидах",
  "ed.postbacks.none": "Партнёрки пока нет — она появится с первым оффером",
  "ed.postbacks.template": "Шаблон {name}",
  "ed.postbacks.give": "Отдайте этот адрес партнёрке {name} — так она сообщит о лиде и его статусе",
  "ed.postbacks.partner": "Партнёрка",
  "ed.postbacks.withTemplate": "{name} · шаблон подставлен",
  "ed.postbacks.goal": "Цель",
  "ed.postbacks.goal.hint": "задаётся у партнёрки",
  "ed.postbacks.goal.default": "основная цель пространства",
  "ed.postbacks.theirs": "Статус у {name}",
  "ed.postbacks.ours": "У нас",
  "ed.postbacks.noMapping": "Слова статусов не заданы — постбеки встанут в холд, пока их не сопоставят на карточке партнёрки",
  "ed.postbacks.last": "{name}: последний постбек {ago} назад",
  "ed.postbacks.never": "{name} ещё не присылала постбек",
  "ed.postbacks.never.hint": "Отправьте тестовый — проверим, что статусы сопоставляются. Реальные лиды придут сами.",
  "ed.postbacks.never.new": "Тестовый постбек — после создания, на тестовом клике.",
  "ed.postbacks.test": "Отправить тестовый",
  "ed.postbacks.testFirst": "Сначала тестовый клик",
  "ed.postbacks.testSent": "Тестовый постбек отправлен — он в Треше, не в апрувах",
  "ed.status.hold": "Холд",
  "ed.status.approved": "Апрув",
  "ed.status.rejected": "Отказ",
  "ed.status.refunded": "Возврат",
  "ed.status.trash": "Треш",
  "ed.status.draft": "Черновик",
  "ed.status.active": "Активна",
  "ed.status.paused": "На паузе",
  "ed.status.archived": "В архиве",
  "ed.review.title": "Проверка",
  "ed.review.sub": "Что получится и что ещё мешает",
  "ed.review.toFix": "поправить: {n}",
  "ed.review.allOk": "всё готово",
  "ed.review.openLander": "Открыть ленд",
  "ed.review.check": "Проверить",
  "ed.review.fix": "Поправить",
  "ed.review.s.clicks": "Клики из {brand} приходят на",
  "ed.review.s.rest": "Остальные:",
  "ed.review.s.all": "Все:",
  "ed.review.s.landers": "Ленды:",
  "ed.review.s.manual": "Расход вручную, периодов: {n}, {sum} USD.",
  "ed.review.s.cost": "Расход: {model}.",
  "ed.check.source": "Источник",
  "ed.check.source.none": "площадка не выбрана",
  "ed.check.pixel": "пиксель {id}",
  "ed.check.pixelHint": "пиксель не указан",
  "ed.check.pixelMissing": "Пиксель {brand} не указан",
  "ed.check.offer": "Оффер с адресом",
  "ed.check.offer.none": "оффер не выбран",
  "ed.check.offer.noAddress": "у «{name}» нет адреса",
  "ed.check.offer.ok": "{n} шт. · {name}, адрес есть",
  "ed.check.landers": "Ленды опубликованы",
  "ed.check.lander.unpublished": "Ленд {name} не опубликован",
  "ed.check.landers.none": "0 из 0",
  "ed.check.landers.n": "{ready} из {total}",
  "ed.check.landers.white": "белая страница на правилах",
  "ed.check.white": "Белая страница",
  "ed.check.white.note": "{name} · правил: {n}",
  "ed.check.domain": "Домен",
  "ed.check.domain.own": "{fqdn} · подключим при сохранении",
  "ed.check.domain.none": "домена нет — ссылке негде жить",
  "ed.check.postback": "Партнёрка знает постбек",
  "ed.check.postback.unchecked": "Постбек {name} не проверен",
  "ed.check.postback.none": "партнёрки пока нет",
  "ed.check.postback.last": "последний {ago} назад",
  "ed.check.postback.never": "{name} ещё не присылала постбек",
  "ed.check.cost": "Расход",
  "ed.check.cost.auto": "из {brand} автоматически",
  "ed.check.cost.manual": "вручную · периодов: {n}, {sum} USD",
  "ed.check.cost.manualNone": "вручную · периодов ещё нет",
  "ed.ready.title": "Готово к запуску",
  "ed.ready.count": "{ok} из {total}",
  "ed.ready.create": "Создать и получить ссылку",
  "ed.ready.create.hint": "можно создать и с жёлтыми пунктами — ссылка заработает, конверсии придут, когда партнёрка настроит постбек",
  "ed.ready.save": "Сохранить",
  "ed.ready.save.hint": "изменения применятся к новым кликам сразу",
  "ed.ready.created": "Кампания создана",
  "ed.ready.createdAt": "создана {at}",
  "ed.ready.alert": "Кампания создана и принимает клики",
  "ed.ready.alert.sub": "Вставьте ссылку в объявления {brand}. Первый клик появится в журнале через несколько секунд.",
  "ed.ready.draft": "Кампания создана, но ещё не принимает клики",
  "ed.ready.draft.sub": "Это черновик: трекер не отдаёт его посетителям, пока кампания не запущена. Ссылку можно скопировать уже сейчас.",
  "ed.ready.draft.why": "Запустить не вышло: {why}",
  "ed.ready.launch": "Запустить",
  "ed.ready.ads": "рекламы",
  "ed.ready.linkFor": "Ссылка для {brand}",
  "ed.ready.noSource": "У кампании нет источника — ссылку не собрать",
  "ed.ready.field": "{label} — в поле «{field}»",
  "ed.ready.address": "Адрес сайта в объявлении",
  "ed.ready.reports": "Что придёт в отчёты",
  "ed.ready.testClick": "Отправить тестовый клик",
  "ed.ready.testHint": "пройдёт по правилам как обычный человек и покажет, куда попал",
  "ed.ready.testWaiting": "ждём тестовый клик…",
  "ed.ready.testArrived": "тестовый клик пришёл {ago} назад · {id}",
  "ed.ready.next": "Дальше",
  "ed.ready.next.postback": "Отдать постбек {name}",
  "ed.ready.next.postback.sub": "без него лиды не дойдут до трекера",
  "ed.ready.next.lander": "Выложить ленд {name}",
  "ed.ready.next.lander.sub": "пока его доля уходит на первый ленд",
  "ed.ready.next.open": "Открыть кампанию",
  "ed.ready.next.open.sub": "клики, лиды, деньги — по мере прихода",
  "ed.ready.next.clicks": "Смотреть клики вживую",
  "ed.ready.next.clicks.sub": "журнал с фильтром по кампании",
  "ed.unsaved.count": "Есть несохранённые изменения: {n}",
  "ed.unsaved.discard": "Отменить",
  "ed.changed.name": "название",
  "ed.changed.source": "источник",
  "ed.changed.platform": "параметры площадки",
  "ed.changed.group": "группа",
  "ed.changed.tags": "теги",
  "ed.changed.notes": "заметки",
  "ed.changed.template": "шаблон потока",
  "ed.changed.offers": "доли офферов",
  "ed.changed.landers": "доли лендов",
  "ed.changed.thankYou": "страница «Спасибо»",
  "ed.changed.rules": "правила потока",
  "ed.changed.branches": "ветки ухода",
  "ed.changed.domain": "домен",
  "ed.changed.path": "адрес кампании",
  "ed.changed.cost": "как считаем расход",
  "ed.changed.costPeriods": "периоды расхода",
  "ed.leave.title": "Уйти без сохранения?",
  "ed.leave.body": "Изменения пропадут: {what}. Кампания продолжит работать как раньше.",
  "ed.leave.stay": "Остаться",
  "ed.leave.go": "Уйти и не сохранять",
  "ed.collapsed.offers": "офферы: {offers} · ленды: {landers}",
  "ed.collapsed.rules": "правил до долей: {n}",
  "ed.collapsed.noRules": "Правил нет — все идут по долям",
  "ed.collapsed.branches": "включено веток: {n}",
  "ed.collapsed.noBranches": "Не настроены — человек, который уходит, просто уходит.",
  "ed.collapsed.review": "поправить: {n}",
  "match.field.region": "Регион",
  "match.field.city": "Город",
  "match.field.isp": "Провайдер (сеть)",
  "match.field.asn": "ASN",
  "match.field.os": "ОС",
  "match.field.browser": "Браузер",
  "match.field.device_type": "Тип устройства",
  "match.field.language": "Язык",
  "match.field.country": "Страна",
  "match.field.ip": "IP-адрес",
  "match.field.user_agent": "User-Agent",
  "match.field.referrer": "Реферер",
  "match.field.param": "Параметр ссылки",
  "match.op.in": "один из",
  "match.op.not_in": "ни один из",
  "match.op.contains": "содержит",
  "match.op.not_contains": "не содержит",
  "match.op.regex": "подходит под regex",
  "match.op.not_regex": "не подходит под regex",
  "match.op.present": "есть",
  "match.op.not_present": "нет",
  "match.values.list": "через запятую; регистр не важен",
  "match.values.ip": "адреса или диапазоны CIDR, v4 или v6, через запятую",
  "match.values.regex": "по шаблону в строке; регистр не важен; без look-around и вложенных повторов",
  "match.w": "Если {field} {op} {values}",
  "ed.rules.f.field": "Поле визита",
};
